import { useState, useEffect, useMemo, useCallback } from 'react'; 
import { useSelector } from 'react-redux';
import { getPermissionNames } from '../utils/permissions';
 
 const usePermission = () => { 
 const userDetails = useSelector((state) => state.auth.userDetails);

 const getInitialData = (userDataRaw) => { 
 const userData = userDataRaw?.user || userDataRaw; 
 if (userData) { 
 try { 
 const userRole = (typeof userData.role === 'string' ? userData.roleName || userData.role : userData.roleName || userData.role?.name || "").toLowerCase(); 
 const finalPermissions = getPermissionNames(userData); 
 
 return { 
 permissions: finalPermissions, 
 role: userRole, 
 isAdmin: userRole === 'admin',
 assignedProjects: userData.assignedProjects || [],
 assignedWOs: userData.assignedWorkOrders || []
 }; 
 } catch (e) { 
 console.error("Error parsing userDetails in usePermission:", e); 
 } 
 } 
 return { permissions: [], role: '', isAdmin: false, assignedProjects: [], assignedWOs: [] }; 
 }; 
 
 const initialData = useMemo(() => getInitialData(userDetails), [userDetails]); 
 const [permissions, setPermissions] = useState(initialData.permissions); 
 const [role, setRole] = useState(initialData.role); 
 const [isAdmin, setIsAdmin] = useState(initialData.isAdmin); 
 const [assignedProjects, setAssignedProjects] = useState(initialData.assignedProjects);
 const [assignedWOs, setAssignedWOs] = useState(initialData.assignedWOs);
 
 useEffect(() => { 
 // Sync with Redux changes
 const data = getInitialData(userDetails); 
 setPermissions(data.permissions); 
 setRole(data.role); 
 setIsAdmin(data.isAdmin); 
 setAssignedProjects(data.assignedProjects);
 setAssignedWOs(data.assignedWOs);
 }, [userDetails]); 
 
 const hasPermission = useCallback((permission) => {
 if (isAdmin || role === 'admin') return true;

 const normalize = (str) => (str || "").toLowerCase().replace(/[:\s_-]/g, "");
 const requested = Array.isArray(permission) ? permission : [permission];

 return requested.some((item) => {
 const normalizedReq = normalize(item);
 return permissions.some(p => normalize(p) === normalizedReq);
 });
 }, [isAdmin, role, permissions]);
 
 return { hasPermission, role, isAdmin, permissions, assignedProjects, assignedWOs }; 
 }; 
 
 export default usePermission; 
